// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-default-index-tsx": () => import("./../src/pages/default/index.tsx" /* webpackChunkName: "component---src-pages-default-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

